var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.mostrarBtnAtualizar)?_c('b-button',{attrs:{"variant":"primary"},on:{"click":function($event){return _vm.toAtualizar()}}},[_vm._v("Atualizar")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }